import { SchemaFormHook } from "@/components/form";
import { Drawer, DrawerProps, ModalHeader } from "@/components/modal";
import OpenCajaForm, { openCajaFormSchema } from "@/features/cajas/caja-actual/components/open-caja-form";
import { useCajaContext } from "@/features/cajas/caja-actual/contexts/caja-context";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { notify } from "@/shared/notification";

export default function OpenCajaModal({ ...props }: DrawerProps) {
    const { open } = useCajaContext();
    const { transferenciaMetodos } = useMonetizacion();

    return <Drawer {...props}>
        <ModalHeader>Abrir Caja</ModalHeader>
        <SchemaFormHook
            schema={openCajaFormSchema}
            onSubmit={async ({ value }) => {
                await open(value);
                notify("La caja se ha abierto correctamente.")
            }}
            defaultValues={{
                transferenciaInicial: {
                    items: transferenciaMetodos.filter(tm => !tm.hidden).map(tm => ({
                        transferenciaMetodoId: tm.id,
                        monto: { items: [] }
                    }))
                }
            }}
            submitOnce
            closeModalOnSubmit
        >
            {form => <OpenCajaForm form={form} padding={3} />}
        </SchemaFormHook>
    </Drawer>
}
